import { render } from "./LoginCodeModal.vue?vue&type=template&id=96e7c36a&scoped=true&ts=true"
import script from "./LoginCodeModal.vue?vue&type=script&lang=ts"
export * from "./LoginCodeModal.vue?vue&type=script&lang=ts"

import "./LoginCodeModal.vue?vue&type=style&index=0&id=96e7c36a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e7c36a"]])

export default __exports__